var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38BCEE",
    d: "M7 3h2v5H7zM15 3h2v5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072F3D",
    d: "M5 11v8h14v-8H5zm9-6v2h-4V5h4zM5 9h14V7h-1V5h3v16H3V5h3v2H5v2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38BCEE",
    d: "M11.673 11.7a.367.367 0 0 1 .654 0l.759 1.532c.053.107.156.18.274.197l1.705.247a.356.356 0 1 1 .202.61l-1.238 1.2a.358.358 0 0 0-.104.316l.292 1.691a.355.355 0 0 1-.146.35.368.368 0 0 1-.383.027l-1.518-.795a.369.369 0 0 0-.34 0l-1.518.795a.368.368 0 0 1-.383-.027.355.355 0 0 1-.146-.35l.292-1.691a.358.358 0 0 0-.104-.316l-1.237-1.2a.356.356 0 0 1 .201-.61l1.704-.247a.363.363 0 0 0 .275-.197l.759-1.531z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEvent);
export default __webpack_public_path__ + "static/media/icons-event.96c98f099c1b85f0584b16122b5e9854.svg";
export { ForwardRef as ReactComponent };